import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SocialIcon } from 'react-social-icons';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

const Footer = () => {

   useEffect(() => {
      (function (d, s, id) {
         var js, fjs = d.getElementsByTagName(s)[0];
         if (d.getElementById(id)) return;
         js = d.createElement(s); js.id = id;
         js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
         fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
   }, [])

   const { t } = useTranslation();

   const showMap = false;

   const someIconStyle = { height: '2rem', width: '2rem' };

   return (
      <div>
         <section className="p-0">
            <div className="container-fluid">
               <div className="bottom-section">
                  <div className="row">
                     <div className={showMap ? "col-md-6 p-0" : "col-12 p-0"}>
                        <div className="address-bar">
                           <div className="container-fluid">
                              <div className="row">
                                 <div className="col-12 p-0 mb-3 text-center">
                                    <div className="footer-style">
                                       <h3 className="title footer-title footer-title-font ourmind-footer">
                                          {t('ourmind oy')}
                                       </h3>
                                       <div className="footer-address">
                                          <a className="p-0 mb-1" href={null}>< PhoneIcon /> {t('companyPhone')}</a>
                                          <a className="p-0 mb-1" href={null}><MailOutlineIcon /> sales@ourmind.io</a>
                                          <a className="p-0 mb-1" href={null}>{t('business id')}: 2895428-7</a>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-12 text-center">
                                    {/*                                     <h3 className="title footer-title">
                                       {t('follow us')}
                                    </h3> */}
                                    <div>
                                       <SocialIcon className="some-button" style={someIconStyle} bgColor="white" fgColor="transparent" url="https://www.facebook.com/ourmindSome/" />
                                       <SocialIcon className="some-button" style={someIconStyle} bgColor="white" fgColor="transparent" url="https://www.linkedin.com/company/ourmind/" />
                                       <SocialIcon className="some-button" style={someIconStyle} bgColor="white" fgColor="transparent" url="https://twitter.com/ourmindSome" />
                                    </div>

                                 </div>
                                 <div className="col-md-4">

                                 </div>
                              </div>
                              <div className="row copyright-text">
                                 <div className="col-12 text-center">
                                    <p>
                                       {t('copyright text', { year: new Date().getFullYear() })}
                                       {t('lang name') === 'suomi' &&
                                          <div className="footer-address m-0">
                                             <a href="https://ourmind.s3-eu-west-1.amazonaws.com/docs/tietosuojaseloste_ourmind_oy.pdf" target="blank">Tietosuojaseloste</a>
                                          </div>
                                       }
                                    </p>

                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     {showMap ? <div className="col-md-6 p-0">
                        <iframe title="google-map" src="https://maps.google.com/maps?q=kynt%C3%A4j%C3%A4ntie%208%20heinola&t=&z=13&ie=UTF8&iwloc=&output=embed" allowFullScreen className="md-height"></iframe>
                     </div> : ''}
                  </div>
                  {/*                   <div className="row">
                     <div className="col-12">
                        <p>{t('copyright text', { year: new Date().getFullYear() })}</p>
                     </div>
                  </div> */}
               </div>

            </div>
         </section>

         {/*          <div className="copyright-section index-footer">
            <p>{t('copyright text', { year: new Date().getFullYear() })}</p>
         </div> */}

         {/*          <div className="tap-top">
            <div>
               <i className="fa fa-angle-double-up"></i>
            </div>
         </div> */}
      </div>
   );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js